import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../context/auth';
import AppRoutes from './routes';

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </AuthProvider>
);

export default App;
